<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { onMount } from 'svelte';
    import { Navigation } from '../../utilities/Navigation';

    import ButtonSmallBlack from '../../shared/ButtonSmallBlack.svelte';
    import JobListFilter from './JobListFilter.svelte';
    import { currentImport } from '../../shared/ColumnSelectPro/currentImport';
    import { ImportApi } from '../Import/ImportApi';
    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import JobList from './JobList.svelte';
    import { debug, jobs, mainMenu } from '../../../stores/store';
    import ProgressBar from '../../shared/ProgressBar.svelte';
    import Separator from '../../shared/Separator.svelte';
    import { api, jobs_filter_config } from '../../../stores/api';
    import { get } from 'svelte/store';
    import JobListQuickSearch from './JobListQuickSearch.svelte';
    import SelectDay from '../../shared/SelectDay.svelte';
    import Checkbox from '../../shared/Checkbox/Checkbox.svelte';
    import { JobApi } from './JobApi';
    import { openModal } from 'svelte-modals';
    import ModalSetTargetDate from '../Modals/ModalSetTargetDate.svelte';
    import ButtonSmallDanger from '../../shared/ButtonSmallDanger.svelte';
    import ModalRemoveSomething from '../Modals/ModalRemoveSomething.svelte';
    import { getFilterQuery } from '../../utilities/getFilterQuery';
    import StatusCircle from './JobStatus/StatusCircle.svelte';
    import { SettingsApi } from '../Settings/SettingsApi';
    import ButtonAddSomething from '../../shared/ButtonAddSomething.svelte';
    import TemplateHeaderDuo from '../../shared/TemplateHeaderDuo.svelte';
    import MenuContextJobs from '../MenuDropdown/MenuContextJobs.svelte';
    import MonitActionForSelectedJob from './MonitActionForSelectedJob.svelte';
    import TemplateHeaderTrio from '../../shared/TemplateHeaderTrio.svelte';
    import GeocodingStatusWithProgressBar from '../Import/GeocodingStatusWithProgressBar.svelte';
    import Switch from '../../shared/Switch.svelte';
    import { features } from '../../shared/Features/features';
    import MenuContextIconJobColorMethod from '../Workshop/MenuContextIconJobColorMethod.svelte';
    import JobAdd from './JobAdd.svelte';
    import IconPending from '../../shared/Icons/IconPending.svelte';

    let showMonit: boolean = false;
    let progressPercent: number = 0;
    let jobsCount: number = -1;
    let loadingJobsFilterConfig: boolean = false;

    onMount(() => {
        console.log('PageJobs.svelte');
        $mainMenu.currentPage = 'PageOrdersToBeCompleted';
        loadingJobsFilterConfig = true;

        Promise.all([SettingsApi.getFilterConfig(get(api), 'job')])
            .then(response => {
                $jobs_filter_config = response[0];
                loadingJobsFilterConfig = false;
            })
            .catch(error => {
                console.error('getFilterConfig', error);
            });
    });

    $: showMonit = $jobs.selectMode === 'filtered' || $jobs.selectedOrUnselected.length > 0;

    $: {
        if (progressPercent >= 100) {
            console.log('progressPercent>=100', progressPercent);
            $jobs.forceReload = true;
            $jobs.forceRecount = true;
        }
    }

    $: {
        if ($jobs.countTotal.count != jobsCount) {
            if (jobsCount >= 0) {
                if ($features.feature_ux_improvements) {
                    let pageOrders = $mainMenu.items.find((i) => i.id == 'PageOrdersToBeCompleted');
                    if (pageOrders?.notification) {
                        pageOrders.notification.reload = true;
                        $mainMenu = $mainMenu;
                    }
                    let pagePlanning = $mainMenu.items.find((i) => i.id == 'PagePlanning');
                    if (pagePlanning?.notification) {
                        pagePlanning.notification.reload = true;
                        $mainMenu = $mainMenu;
                    }
                }
            }
            jobsCount = $jobs.countTotal.count;
        }
    }
</script>

{#if loadingJobsFilterConfig}
    <div style="padding: 20px; text-align: center;">
        <IconPending scale={0.6} spin={true} />
    </div>
{:else}
<TemplateStandard>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderTrio flexAlign="start">
            <div slot="main-header">
                {$_('To be completed')}
            </div>
            <div slot="main-search">
                <GeocodingStatusWithProgressBar
                    bind:progressPercent
                    error=""
                    autoHideWhenInactive={true}
                />
            </div>
            <div slot="main-buttons" style="display:flex; align-items: {($features.feature_ux_improvements ? 'start' : 'center')}; column-gap: 25px;">
                {#if !$features.feature_ux_improvements}
                    <div style="font-size: 12px; display: flex; align-items: center; column-gap: 10px;">
                        <Switch
                            checked={$jobs.showOnlyToDo}
                            label={get(_)("Only_unassigned")}
                            on:change={() => {
                                $jobs.showOnlyToDo = !$jobs.showOnlyToDo;
                                $jobs.forceReload = true;
                            }}
                        />
                    </div>
                {/if}
                {#if $features.feature_ux_improvements}
                    <JobAdd/>
                {/if}
                {#if $features?.feature_enable_to_change_job_color_method}
                    <div style="{($features.feature_ux_improvements ? 'padding-top: 5px' : '')}">
                        <MenuContextIconJobColorMethod />
                    </div>
                {/if}
                {#if !$features.feature_ux_improvements}
                    <MenuContextJobs />
                {/if}
            </div>
        </TemplateHeaderTrio>
    </div>
    <div slot="content-header"></div>
    <div slot="monit">
        {#if showMonit}
            <div style="position: relative;">
                <MonitActionForSelectedJob />
            </div>
        {/if}
    </div>
    <div slot="content" style="display: flex; flex-direction: column; overflow-y: auto;">
        <!--{#if loading && progressPercent>0}-->
        <!--    <Separator />-->
        <!--    <ProgressBar current={progressPercent} withShadow={true} label="Geocoding" />-->
        <!--{/if}-->
        <JobList {showMonit} />
    </div>
    <div slot="footer"></div>
</TemplateStandard>
{/if}

<style>
</style>
